import LinkedInPipelinePage from "../features/crm/LinkedInPipelinePage";

export default function CrmLinkedInPipelineRoute() {
  return <LinkedInPipelinePage />;
}
